import ScrollTrigger from 'gsap/ScrollTrigger';

window.addEventListener('load', () => {
    gsap.registerPlugin(ScrollTrigger);

    const slideUpEls = document.querySelectorAll('.slide-up');

    slideUpEls.forEach(slideUpEl => {
        gsap.fromTo(slideUpEl, {
            yPercent: 50,
        }, {
            yPercent: 0,
            autoAlpha: 1,
            duration: 0.5,
            scrollTrigger: slideUpEl,
        });
    });

    const priceGroups = document.querySelectorAll('.price-group');

    if (priceGroups.length) {
        gsap.fromTo(priceGroups, {
            yPercent: 20,
        }, {
            yPercent: 0,
            autoAlpha: 1,
            stagger: 0.1,
            scrollTrigger: '.prices'
        });
    }

    const vimeoHolder = document.querySelector('.video-holder');

    const vimeoPlayer = new Vimeo.Player(
        vimeoHolder.querySelector('iframe'),
    );

    vimeoPlayer.pause();

    vimeoPlayer.play().then(() => {
        vimeoHolder.classList.add('playing');
    });

    const audioToggles = document.querySelectorAll('.video-toggle-audio');

    audioToggles.forEach(audioToggle => {
        audioToggle.addEventListener('click', e => {
            e.preventDefault();

            if (audioToggle.classList.contains('muted')) {
                vimeoPlayer.setVolume(1);

                audioToggles.forEach(audioToggle => {
                    audioToggle.classList.remove('muted');
                });

                return;
            }

            vimeoPlayer.setVolume(0);

            audioToggles.forEach(audioToggle => {
                audioToggle.classList.add('muted');
            });
        });
    });
});
